export default __webpack_public_path__ + "static/media/return-red.a9e47b76.svg";